import SEOHead from '@/components/base/SEOHead';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import Breadcrumb from '@/components/feature/Breadcrumb';
import { Link } from 'react-router-dom';

export default function About() {
  const aboutSchema = {
    '@context': 'https://schema.org',
    '@type': 'AboutPage',
    name: '关于51漫画',
    description: '51漫画是一个免费在线漫画阅读平台，提供海量热门漫画在线阅读服务。',
    url: 'https://51manhua.com/about',
    inLanguage: 'zh-CN',
  };

  const orgSchema = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '51漫画',
    url: 'https://51manhua.com/',
    description: '51漫画 - 免费在线漫画阅读平台，提供海量热门漫画、日漫、国漫、韩漫在线阅读。',
    foundingDate: '2020',
    contactPoint: {
      '@type': 'ContactPoint',
      telephone: '+86-400-123-4567',
      contactType: 'customer service',
      email: 'contact@51manhua.com',
      availableLanguage: ['Chinese'],
    },
    sameAs: [
      'https://weibo.com/51manhua',
      'https://space.bilibili.com/51manhua',
    ],
  };

  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: [
      {
        '@type': 'Question',
        name: '51漫画是否免费？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '是的，51漫画完全免费。我们提供海量漫画资源的在线免费阅读服务，无需付费即可畅享热门漫画、日漫、国漫、韩漫等丰富内容。',
        },
      },
      {
        '@type': 'Question',
        name: '51漫画支持哪些设备阅读？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '51漫画完美适配电脑、平板和手机等多种设备。无论您使用什么设备，都能获得流畅舒适的在线阅读体验。网页端直接打开，无需下载任何APP。',
        },
      },
      {
        '@type': 'Question',
        name: '51漫画的更新频率如何？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '51漫画每日实时更新，紧跟各大漫画平台的最新连载进度。热门漫画保持日更或周更频率，确保读者能第一时间阅读到最新内容。',
        },
      },
      {
        '@type': 'Question',
        name: '如何搜索想看的漫画？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '您可以通过51漫画顶部的搜索框直接搜索漫画名称，也可以通过分类导航浏览热血、恋爱、搞笑、玄幻等不同类型的漫画作品。',
        },
      },
    ],
  };

  const stats = [
    { number: '10万+', label: '收录漫画' },
    { number: '500万+', label: '注册用户' },
    { number: '99.7%', label: '好评率' },
    { number: '24h', label: '实时更新' },
  ];

  const teamMembers = [
    {
      name: '林晓',
      role: '创始人 & CEO',
      desc: '资深漫画爱好者，拥有10年互联网产品经验，致力于打造最好的中文漫画阅读平台。',
      avatar: 'https://readdy.ai/api/search-image?query=professional%20Chinese%20male%20portrait%20in%20casual%20style%2C%20young%20tech%20entrepreneur%2C%20warm%20friendly%20expression%2C%20clean%20white%20background%2C%20modern%20corporate%20headshot&width=200&height=200&seq=about-team-01&orientation=squarish',
    },
    {
      name: '陈思雨',
      role: '内容总监',
      desc: '前漫画杂志主编，深耕漫画行业8年，负责平台内容策略和版权合作。',
      avatar: 'https://readdy.ai/api/search-image?query=professional%20Chinese%20female%20portrait%20in%20modern%20style%2C%20young%20professional%2C%20warm%20confident%20expression%2C%20clean%20white%20background%2C%20corporate%20headshot&width=200&height=200&seq=about-team-02&orientation=squarish',
    },
    {
      name: '王浩然',
      role: '技术总监',
      desc: '全栈工程师，曾在头部互联网公司担任技术负责人，负责平台技术架构和性能优化。',
      avatar: 'https://readdy.ai/api/search-image?query=professional%20Chinese%20male%20engineer%20portrait%2C%20young%20tech%20professional%2C%20friendly%20expression%2C%20clean%20white%20background%2C%20modern%20corporate%20headshot&width=200&height=200&seq=about-team-03&orientation=squarish',
    },
  ];

  const testimonials = [
    {
      name: '漫画迷小王',
      text: '51漫画真的是我用过最好的在线漫画平台！页面简洁，加载快，下拉式阅读体验太爽了。推荐给所有喜欢看漫画的朋友！',
      rating: 5,
    },
    {
      name: '二次元少女',
      text: '每天必刷的一个网站，漫画种类超级全，日漫国漫韩漫都有。更新速度也很快，追更体验特别好。',
      rating: 5,
    },
    {
      name: '老书虫',
      text: '从2020年就开始用51漫画了，见证了它一步步发展壮大。现在漫画资源越来越丰富，阅读体验也越来越好。',
      rating: 5,
    },
  ];

  return (
    <>
      <SEOHead
        title="关于我们"
        description="51漫画是一个免费的在线漫画阅读平台，提供海量热门漫画在线阅读服务。了解我们的品牌故事、团队介绍和联系方式。"
        keywords="51漫画,关于51漫画,在线漫画平台,免费漫画,漫画阅读"
        canonicalUrl="https://51manhua.com/about"
        schemaObjects={[aboutSchema, orgSchema, faqSchema]}
      />

      <Navbar />

      <main className="pt-20">
        {/* Hero */}
        <section className="py-14 md:py-20 bg-background-100">
          <div className="px-4 md:px-6">
            <div className="max-w-6xl mx-auto text-center">
              <Breadcrumb
                items={[
                  { label: '首页', to: '/' },
                  { label: '关于我们' },
                ]}
              />
              <div className="w-16 h-16 flex items-center justify-center bg-primary-500 rounded-2xl mx-auto mt-8 mb-6">
                <i className="ri-book-read-line text-3xl text-background-50"></i>
              </div>
              <h1 className="text-3xl md:text-4xl font-heading font-bold text-foreground-900 mb-4">关于51漫画</h1>
              <p className="text-sm md:text-base text-foreground-600 max-w-2xl mx-auto leading-relaxed">
                让每一个热爱漫画的人，都能随时随地享受阅读的乐趣。
              </p>
            </div>
          </div>
        </section>

        {/* Brand Story */}
        <section className="py-14 md:py-20 bg-background-50">
          <div className="px-4 md:px-6">
            <div className="max-w-6xl mx-auto">
              <div className="flex flex-col md:flex-row items-center gap-10">
                <div className="flex-1">
                  <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-4">我们的故事</h2>
                  <p className="text-sm text-foreground-600 leading-relaxed mb-4">
                    51漫画成立于2020年，由一群热爱漫画的互联网人创立。我们深知漫画爱好者的需求——快速加载、高清画质、流畅阅读、丰富内容。
                  </p>
                  <p className="text-sm text-foreground-600 leading-relaxed mb-4">
                    从最初只有几百部漫画的小平台，到如今收录超过10万部漫画的大型在线阅读平台，51漫画始终坚持<strong>免费、高速、全面</strong>的服务理念。
                  </p>
                  <p className="text-sm text-foreground-600 leading-relaxed">
                    我们的团队遍布北京、上海、广州、深圳等城市，核心成员来自知名互联网公司和漫画出版行业。我们相信，<strong>好的漫画应该被更多人看到</strong>。
                  </p>
                </div>
                <div className="flex-1">
                  <img
                    src="https://readdy.ai/api/search-image?query=modern%20creative%20office%20workspace%20with%20manga%20art%20on%20walls%2C%20young%20Chinese%20team%20brainstorming%2C%20warm%20cozy%20atmosphere%2C%20natural%20light%2C%20creative%20studio%20vibe%2C%20minimal%20design%2C%20clean%20aesthetic&width=800&height=500&seq=about-story&orientation=landscape"
                    alt="51漫画团队工作场景"
                    className="w-full rounded-xl"
                  />
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Stats */}
        <section className="py-10 md:py-14 bg-primary-500">
          <div className="px-4 md:px-6">
            <div className="max-w-6xl mx-auto">
              <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
                {stats.map((stat, index) => (
                  <div key={index} className="text-center">
                    <p className="text-3xl md:text-4xl font-heading font-bold text-background-50 mb-1">{stat.number}</p>
                    <p className="text-sm text-background-50/80">{stat.label}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>

        {/* Team */}
        <section className="py-14 md:py-20 bg-background-100">
          <div className="px-4 md:px-6">
            <div className="max-w-6xl mx-auto">
              <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 text-center mb-2">核心团队</h2>
              <p className="text-sm text-foreground-500 text-center mb-10">一群热爱漫画的人，用心做好每一个细节</p>
              <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
                {teamMembers.map((member, index) => (
                  <div key={index} className="bg-background-50 rounded-xl p-6 text-center">
                    <img
                      src={member.avatar}
                      alt={member.name}
                      className="w-20 h-20 rounded-full object-cover mx-auto mb-4"
                    />
                    <h3 className="text-sm font-heading font-bold text-foreground-900">{member.name}</h3>
                    <p className="text-xs text-primary-500 font-medium mb-3">{member.role}</p>
                    <p className="text-xs text-foreground-600 leading-relaxed">{member.desc}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>

        {/* Testimonials */}
        <section className="py-14 md:py-20 bg-background-50">
          <div className="px-4 md:px-6">
            <div className="max-w-6xl mx-auto">
              <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 text-center mb-2">用户口碑</h2>
              <p className="text-sm text-foreground-500 text-center mb-10">来自数百万用户的真实评价</p>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                {testimonials.map((t, index) => (
                  <div key={index} className="bg-background-100 rounded-xl p-6">
                    <div className="flex items-center gap-1 mb-3">
                      {Array.from({ length: t.rating }).map((_, i) => (
                        <i key={i} className="ri-star-fill text-accent-500 text-sm"></i>
                      ))}
                    </div>
                    <p className="text-sm text-foreground-700 leading-relaxed mb-4">&ldquo;{t.text}&rdquo;</p>
                    <p className="text-xs font-medium text-foreground-900">— {t.name}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>

        {/* FAQ */}
        <section className="py-14 md:py-20 bg-background-100">
          <div className="px-4 md:px-6">
            <div className="max-w-3xl mx-auto">
              <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 text-center mb-10">常见问题</h2>
              <div className="space-y-3">
                {faqSchema.mainEntity.map((faq, index) => (
                  <details key={index} className="bg-background-50 rounded-xl group">
                    <summary className="px-6 py-4 cursor-pointer text-sm font-medium text-foreground-900 flex items-center justify-between">
                      {faq.name}
                      <i className="ri-arrow-down-s-line transition-transform group-open:rotate-180"></i>
                    </summary>
                    <div className="px-6 pb-4 text-sm text-foreground-600 leading-relaxed">
                      {faq.acceptedAnswer.text}
                    </div>
                  </details>
                ))}
              </div>
            </div>
          </div>
        </section>

        {/* Contact */}
        <section className="py-14 md:py-20 bg-background-50">
          <div className="px-4 md:px-6">
            <div className="max-w-6xl mx-auto">
              <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 text-center mb-2">联系我们</h2>
              <p className="text-sm text-foreground-500 text-center mb-10">有任何问题或建议，欢迎随时联系我们</p>
              <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-6">
                <div className="text-center p-6 rounded-xl bg-background-100">
                  <div className="w-12 h-12 flex items-center justify-center rounded-full bg-primary-100 text-primary-600 mx-auto mb-3">
                    <i className="ri-mail-line text-xl"></i>
                  </div>
                  <h3 className="text-sm font-heading font-bold text-foreground-900 mb-1">电子邮箱</h3>
                  <p className="text-xs text-foreground-500">contact@51manhua.com</p>
                </div>
                <div className="text-center p-6 rounded-xl bg-background-100">
                  <div className="w-12 h-12 flex items-center justify-center rounded-full bg-primary-100 text-primary-600 mx-auto mb-3">
                    <i className="ri-phone-line text-xl"></i>
                  </div>
                  <h3 className="text-sm font-heading font-bold text-foreground-900 mb-1">客服电话</h3>
                  <p className="text-xs text-foreground-500">400-123-4567</p>
                </div>
                <div className="text-center p-6 rounded-xl bg-background-100">
                  <div className="w-12 h-12 flex items-center justify-center rounded-full bg-primary-100 text-primary-600 mx-auto mb-3">
                    <i className="ri-weibo-line text-xl"></i>
                  </div>
                  <h3 className="text-sm font-heading font-bold text-foreground-900 mb-1">官方微博</h3>
                  <p className="text-xs text-foreground-500">@51漫画官方</p>
                </div>
                <div className="text-center p-6 rounded-xl bg-background-100">
                  <div className="w-12 h-12 flex items-center justify-center rounded-full bg-primary-100 text-primary-600 mx-auto mb-3">
                    <i className="ri-map-pin-line text-xl"></i>
                  </div>
                  <h3 className="text-sm font-heading font-bold text-foreground-900 mb-1">公司地址</h3>
                  <p className="text-xs text-foreground-500">北京市朝阳区漫画大厦</p>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>

      <Footer />
      <ScrollToTop />
    </>
  );
}